const VALIDATION_SERVICE = 'https://www.nuskin.com/validate-service/api/v1/email/address.json?address='
const RESPONSE_PATH = 'data.valid'

const MAX_RETRIES = 3;

import { axios, axiosRetry } from '@nuskin/axios-util';
import { AuthenticationService } from '../src/account';

const myAxios = axios.create();
axiosRetry(myAxios, {
    retries: MAX_RETRIES,
    shouldResetTimeout: true,
    retryDelay: (retryCount) => {
        return retryCount * 200;
    }
});

async function validateEmail(emailInput, checkService = true, checkForDuplicates = true, validationServiceUrl = VALIDATION_SERVICE) {
    let isServiceValid = true
    let isEmailAvailable = true
    try {
        if (checkForDuplicates) {
            isEmailAvailable = await validateDuplicateEmails(emailInput)
        }
    } catch (e) {
        console.log(e)
    }
    if (checkService) {
        isServiceValid = await validateEmailUsingService(emailInput, validationServiceUrl)
    }
    return [isServiceValid, isEmailAvailable]
}

async function validateEmailUsingService(emailInput, validationServiceUrl = VALIDATION_SERVICE , validationServiceValidResponsePath = RESPONSE_PATH) {
    let isServiceValid = true;

    try {
        const response = await myAxios.get(validationServiceUrl + encodeURIComponent(emailInput));

        isServiceValid = getValueByKey(
            validationServiceValidResponsePath,
            response
        );
    } catch (e) {
        console.log("Error checking email service");
    }

    return isServiceValid
}

function validateDuplicateEmails(emailInput) {
    return new Promise((resolve, reject) => {
        try {
            AuthenticationService.isUsernameAvailable(
                emailInput,
                (error, response) => {
                    if (!error) {
                        resolve(response.data.available);
                    } else {
                        reject("Error checking for duplicate emails")
                    }
                }
            );
        } catch (e) {
            console.log("Error checking for duplicate emails")
            reject(e)
        }
    })
}

function getValueByKey(key, obj) {
    return key.split('.').reduce(function (a, b) {
        return a && a[b];
    }, obj);
}

export default {
    validateEmail,
    validateEmailUsingService,
    validateDuplicateEmails
}
